export enum AnalyticsIdElement {
    INPUT = "input",
    BUTTON = "button",
    LINK = "link",
    GTM_LOGIN_BUTTON = "gtm-login-button",
    NOT_FOUND = "not-found",
}
